import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewTypeHoursCodeStore, CreateTypeHoursCodeDto } from 'stores/configuration/events-n-requests/type-hour-code-store';
import { nameof } from 'utils/object';

interface NewTypeHoursCodeViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newTypeHoursCode?: NewTypeHoursCodeStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewTypeHoursCodeViewState {
  userClickedSaved: boolean;
}

@connect(['newTypeHoursCode', NewTypeHoursCodeStore])
class NewTypeHoursCodeView extends React.Component<NewTypeHoursCodeViewProps, NewTypeHoursCodeViewState> {
  private get newTypeHoursCodeStore() {
    return this.props.newTypeHoursCode;
  }

  constructor(props: NewTypeHoursCodeViewProps) {
    super(props);
    this.newTypeHoursCodeStore.createNew({
      code: ''
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewTypeHoursCodeViewProps) {
    if (this.newTypeHoursCodeStore.state.result && this.newTypeHoursCodeStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newTypeHoursCodeStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newTypeHoursCodeStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newTypeHoursCodeStore.change({ ...this.newTypeHoursCodeStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newTypeHoursCodeStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Type Hours Code')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newTypeHoursCodeStore.state.result && !this.newTypeHoursCodeStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newTypeHoursCodeStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newTypeHoursCodeStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!this.newTypeHoursCodeStore.state.item.code && this.state.userClickedSaved}
                    label={t('Type Hours Code')}
                    placeholder={t('Code')}
                    maxLength={5}
                    value={this.newTypeHoursCodeStore.state.item.code}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateTypeHoursCodeDto>('code'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewTypeHoursCodeView);
